import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import { onError/*, onSuccess*/ } from '../shared/messages';
import { GetTransactionCodes, CalculateAmountTax, CalculateFolioTransactionsByTargetCurrencyId } from '../../api/services/finance';
import { useTextResources } from '../../language';
import { List, Button, Input } from 'semantic-ui-react';
import Panel from '../shared/Panel';
import { Currencies } from '../shared/currencies';
import ShopItem from "./ShopItem";
import './style.css';

const ShopItems = ({ currency, hotelID, includeTax, folioId }) => {
  const text = useTextResources()
  const [shopItems, setShopItems] = useState()
  const [filteredShopItems, setFilteredShopItems] = useState()

  const [totalShopAmount, setToalShopAmount] = useState(0)
  const [totalShopAmountCurrency, setToalShopAmountCurrency] = useState(currency)
  const [searchValue, setSearchValue] = useState("")

  useEffect(() => {
    const chosenItems = shopItems && shopItems.filter(item => item.Chosen);
    let total = 0;
    let needToConvert = false
    let totalCurrecny = currency
    let uniqueCurrenciesInChosenItems = chosenItems && [...new Set(chosenItems.map(item => item.CurrencyId))];
    if (uniqueCurrenciesInChosenItems) {
      if (uniqueCurrenciesInChosenItems.length > 1) {
        //convert all to main currency
        needToConvert = true
      }
      else {
        totalCurrecny = uniqueCurrenciesInChosenItems[0]
      }
    }
    chosenItems && chosenItems.forEach(item => {
      const quantity = item.Quantity || 1;
      if (needToConvert && item.CurrencyId != currency) {
        total += item.TransactionCodeHotelTaxes != null && item.TransactionCodeHotelTaxes.length > 0 ?
          item.AmountAfterTaxByTargetCurrencyID * quantity :
          item.AmountBeforeTaxByTargetCurrencyID * quantity;
      }
      else {
        total += item.TransactionCodeHotelTaxes != null && item.TransactionCodeHotelTaxes.length > 0 ?
          item.AmountAfterTax * quantity :
          item.AmountBeforeTax * quantity;
      }
    })
    setToalShopAmount(total)
    setToalShopAmountCurrency(totalCurrecny)
  }, [currency, shopItems])

  useEffect(() => {
    if (folioId && hotelID && currency) {
      (async () => {
        try {
          let result = await GetTransactionCodes({
            ShowInShop: true,
            TargetCurrencyId: currency,
            HotelId: hotelID,
            IsDebit: true,
            IncludeHotelTaxes: true
          })
          if (result && result.length && folioId) {
            result = result.filter(item => item.CurrencyId && (item.AmountAfterTax || item.AmountBeforeTax))
            if (result.length) {
              const folioTransactions = result.map(trans => {
                return {
                  ...trans,
                  FolioId: folioId,
                  HotelID: hotelID,
                  Quantity: 1,
                  TransactionCodeId: trans.Id,
                  TargetCurrencyId: trans.CurrencyId,
                  Id: null
                }
              })
              const transactionsCalculated = await CalculateAmountTax({
                HotelId: hotelID,
                IsProductPricingIncludeTax: includeTax,
                Transactions: folioTransactions
              });
              const specForFolioTransactionsByTargetCurrencyId = transactionsCalculated && transactionsCalculated.map(item => {
                return {
                  ...item,
                  TargetCurrencyId: currency
                }
              }
              );
              const transactionsCalculatedWithTargetCurrency = await CalculateFolioTransactionsByTargetCurrencyId({
                FolioTransactions: specForFolioTransactionsByTargetCurrencyId,
                TargetCurrencyId: currency
              });
              const UpdatedTransactionCodesWithPrices = result.map(trans => {
                const transCalulated = transactionsCalculatedWithTargetCurrency && transactionsCalculatedWithTargetCurrency.find(t => t.TransactionCodeId === trans.Id)
                return {
                  ...trans,
                  Quantity: 1,
                  AmountAfterTax: transCalulated.AmountAfterTax,
                  AmountBeforeTax: transCalulated.AmountBeforeTax,
                  AmountAfterTaxOrig: transCalulated.AmountAfterTax,
                  AmountBeforeTaxOrig: transCalulated.AmountBeforeTax,
                  AmountAfterTaxByMainCurrencyID: transCalulated.AmountAfterTaxByMainCurrencyID,
                  AmountAfterTaxByTargetCurrencyID: transCalulated.AmountAfterTaxByTargetCurrencyID,
                  AmountBeforeTaxByMainCurrencyID: transCalulated.AmountBeforeTaxByMainCurrencyID,
                  AmountBeforeTaxByTargetCurrencyID: transCalulated.AmountBeforeTaxByTargetCurrencyID,
                }
              })
              setShopItems(UpdatedTransactionCodesWithPrices)
            }
          }
        } catch (error) {
          onError(error)
        }
      })()
    }
  }, [currency, hotelID, folioId])

  useEffect(() => {
    handleSearchChange()
  }, [shopItems, searchValue])

  const handleSearchChange = () => {
    const filtered = shopItems && shopItems.filter(item => item.Name && item.Name.toUpperCase().includes(searchValue.toUpperCase()))
    setFilteredShopItems(filtered)
  }

  const addChosenItemsAsTransactions = () => {
    const chosenItems = shopItems && shopItems.filter(item => item.Chosen);
    const folioTransactionsToAdd = chosenItems && chosenItems.map(item => {
      return {
        ...item,
        Quantity: item.Quantity || 1,
        TransactionCodeId: item.Id,
        TransactionDisplayName: item.Name,
        Id: null
      }
    })
    window.postMessage({
      eventType: "addTransaction",
      transactions: JSON.stringify(folioTransactionsToAdd)
    }, "*")
    resetChosen();
  }

  const resetChosen = async () => {
    const resetItems = shopItems && shopItems.map(item => {
      return {
        ...item,
        Chosen: null,
        Quantity: 1,
        AmountAfterTax: item.AmountAfterTaxOrig,
        AmountBeforeTax: item.AmountBeforeTaxOrig
      }
    })
    setShopItems(resetItems)
  }

  const updateItems = () => {
    setShopItems([...shopItems])
  }

  const price = (value, currencyId) => {
    const c = Currencies[currencyId]
    return `${value.toFixed(2)} ${c ? c.symbol : ''}`
  }

  return <Panel header={text("OptimaShop")} attached={true}>
    <Input fluid icon='search' placeholder='Search...' value={searchValue} onChange={(val) => setSearchValue(val.target.value)} />
    {shopItems &&
      <div className="item-shop-summary header-wrapper">
        <div className="shop-total">
          <span className="total-title">{text("Total")}</span>
          <span className="total-amount">
            {price(totalShopAmount, totalShopAmountCurrency)}
          </span>
        </div>
        <Button primary
          onClick={addChosenItemsAsTransactions}
          disabled={totalShopAmount == 0}
        >
          {text("SaveTransaction")}
        </Button>
      </div>
    }
    <div className="item-shop-list">
      {filteredShopItems &&
        <List selection divided verticalAlign='middle'>
          {filteredShopItems.map((item) => {
            return <ShopItem
              key={item.Id}
              item={item}
              updateItems={updateItems}
              price={price}
              currency={item.CurrencyId}
            />
          }
          )}
        </List>
      }
    </div>
  </Panel>
}

ShopItems.propTypes = {
  reservationID: PropTypes.number,
  hotelID: PropTypes.number,
  currency: PropTypes.number,
  includeTax: PropTypes.bool,
  folioId: PropTypes.number
}
export default ShopItems